/*global dc*/

const $ = require('jquery');

const manageButtonTemplate = '<a class="btn manage-dc" ng-show="showManageDynamicContent">Manage Dynamic Content</a>';

module.exports = function (dynamicContentService, $window) {
    return {
        restrict: 'A',
        scope: {
            scheduleKey: '@',
            layoutId: '@'
        },
        link(scope, element) {
            const centerScroll = $('#center-panel > .hideScroll-wrapper');

            function manageDynamicContent() {
                if (scope.scheduleKey !== undefined) {
                    $('.manage-dc').remove();
                    dc.service.baseUrl = $window.config.apiUrl;
                    dc.initialize(element, scope.scheduleKey, scope.layoutId);
                    // If the dc is at the bottom, sometimes we need to scroll to it
                    // in order to be able to edit.
                    centerScroll.scrollTop(element.position().top);
                }
            }

            scope.getManageTemplates = function () {
                dynamicContentService.getManageTemplates().then(function (data) {
                    $(document.body).append(data);

                    //inject data somewhere
                    scope.showManageDynamicContent = true;
                });
            };

            scope.getManageTemplates();

            element.append($(manageButtonTemplate));

            element.find('.manage-dc').one('click', manageDynamicContent);
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/manage-dc-directive.js
 **/